import { render, staticRenderFns } from "./PlayStation.vue?vue&type=template&id=325e4662"
import script from "./PlayStation.vue?vue&type=script&lang=js"
export * from "./PlayStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports